import React from 'react';
import { SVGIcon } from '@pearsontechnology/aero-components-learnspace';

import { Container, Title, Text, Divider } from './styles';

const NotFound = () => (
  <Container>
    <SVGIcon
      icon="duotoneClass"
      viewBox="0 0 24 24"
      size={{ width: '64px', height: '64px' }}
    />
    <Divider />
    <Title>We couldn&apos;t load this page.</Title>
    <Divider />
    <Text>


      Wait a few minutes and refresh. If the problem continues, contact Pearson Support.
    </Text>
  </Container>
);

export default NotFound;
